/** Lightweight Expo Router history entry. The Learn layout owns the persistent map (`MapLayer`). */
export function MapPage() {
  // eslint-disable-next-line han-page-components/no-blank-page -- History-only leaf; LearnLayout renders the persistent, visible MapLayer beneath this route.
  return null;
}
